export const environment = {
  production: false,
  apiBaseUrl: 'https://api-dev.resumir.ai',
  webUrl: 'https://dev.resumir.ai',
  paypalClientId: 'ATSky4G0e4LFgkwiQ0aO1eONFWnCnYZpoTHrORxKq-fJw4lzjOsdHx8-V0WjKHSWgNVhr_jsI_jAeZVo',
  growthPlanId: 'P-3E841572WE954714KNBI5N5I',
  ultimatePlanId: 'P-8H201112SX495202ENBI5MAY',
};
